export default "__VITE_ASSET__FgI0nFw9__"